import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0516 from "../lesson-16/lesson";
import lesson0518 from "../lesson-18/lesson";
import lesson0523 from "../lesson-23/lesson";
import lesson0529 from "../lesson-29/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "452724b1-7ac2-48c6-8614-eee0dc3d0a8f",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0516),
    lesson: lesson0516,
  },
  {
    id: "0d64e974-da4d-4782-89bd-6775fbb5b335",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0518),
    lesson: lesson0518,
  },
  {
    id: "b3ddd119-a070-4b37-aa19-30e0739caf69",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0523),
    lesson: lesson0523,
  },
  {
    id: "d5926880-aa7a-4441-91ae-a40966592cc1",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0529),
    lesson: lesson0529,
  },
];

export default lessonLinks;
